import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {
    execute,
    grab
} from './lang.js';

class Grab extends ScriptingEffect {
    constructor(track) {
        super("Grab", track);
        this.newTrackVar("trackNumber", null, 0, 64);
        this.newParamVar("fromParam", "", 0, 64);
        this.newParamVar("toParam", "", 0, 64);
        this.newCheckboxVar('add', false);
        this.clear();
    }

    get documentation() {
        return [
            "Sets a parameter for this track to a value grabbed from a different track.",
            "If there are no triggers at a given step, then the original value will play."
            ];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            grab(
                this.var('trackNumber'),
                this.var('fromParam'),
                this.var('toParam'),
                this.var('add')
            ));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track=this.track, ignoreId=true) {
        let fx = new Grab(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}

export default Grab;
